import React, {PureComponent} from "react"
import * as PropTypes from "prop-types"

import {injectIntl, FormattedMessage} from "@irati/utils/lang"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import {H4} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"

class DateOfBirthRequiredBlock extends PureComponent {
  static contextTypes = {
    apps: PropTypes.object.isRequired
  }
  render() {
    return (
      <>
        <H4 textAlign="center" marginBottom={2}>
          <FormattedMessage
            id="perks.redemptionEvents.dateOfBirthRequiredBlock.header"
            values={{
              boldText: (
                <>
                  <br />
                  <strong>
                    <FormattedMessage id="perks.redemptionEvents.dateOfBirthRequiredBlock.boldText" />
                  </strong>
                </>
              )
            }}
          />
        </H4>
        <Flex justifyContent="center">
          <ButtonRouterLink to="/" app={this.context.apps.ACCOUNT}>
            <FormattedMessage id="perks.redemptionEvents.dateOfBirthRequiredBlock.buttonText" />
          </ButtonRouterLink>
        </Flex>
      </>
    )
  }
}

export default injectIntl(DateOfBirthRequiredBlock)
